<div class="container py-5">
  <h1 class="text-center mb-4">Subscription Plans</h1>
  <p class="text-center text-muted mb-5">
    All plans include a <strong>30-day free trial</strong>. Cancel anytime.
  </p>

  <div data-live-pricing class="row row-cols-1 row-cols-md-4 mb-3 g-4" *ngIf="hasPlans(); else noPlans">
    <div class="col" *ngFor="let plan of plans()">
      <div class="card h-100 rounded-3 shadow-sm" [class.border-primary]="plan.featured">
        <div class="card-header py-3" [ngClass]="{ 'bg-primary text-white': plan.featured, 'bg-light': !plan.featured }">
          <h4 class="my-0 fw-normal text-center">{{ plan.name }}</h4>
        </div>
        <div class="card-body px-4 text-start">
          <p class="card-title pricing-card-title text-center fs-1 fw-semibold">
            {{ plan.price | currency:(plan.currency || 'EUR'):'symbol':'1.0-2' }}
            <small class="text-muted fw-light">
              {{ plan.billingPeriod === 'one-time' ? 'one-time' : '/' + (plan.billingPeriod === 'monthly' ? 'mo' : 'yr') }}
            </small>
          </p>

          <ul class="list-unstyled mt-3 mb-4">
            <li><strong>{{ plan.boats }}</strong></li>
            <li class="text-muted">{{ plan.description }}</li>
            <li class="mt-2" *ngFor="let condition of plan.conditions">
              <span class="badge bg-light text-dark border">{{ condition }}</span>
            </li>
            <li class="mt-3" *ngFor="let feature of plan.features">
              <i class="bi bi-check-circle-fill text-success me-2"></i>{{ feature }}
            </li>
          </ul>

          <div *ngIf="plan.addons?.length">
            <h6 class="fw-bold">Add More Boats</h6>
            <ul class="list-unstyled small text-muted">
              <li *ngFor="let addon of plan.addons ?? []">
                +{{ addon.boats }} boats: {{ addon.price | currency:(plan.currency || 'EUR'):'symbol':'1.0-2' }}/{{ plan.billingPeriod === 'one-time' ? 'one-time' : (plan.billingPeriod === 'monthly' ? 'month' : 'year') }}
              </li>
            </ul>
          </div>

          <div class="text-center mt-4">
            <button type="button" 
              (click) = "selectPlanAndNavigate(plan)"
              class="w-100 btn btn-lg" [ngClass]="{ 'btn-outline-primary': !plan.featured, 'btn-primary': plan.featured }">
              {{ plan.buttonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noPlans>
    <div data-live-pricing class="text-center text-muted">Loading subscription plans…</div>
  </ng-template>
</div>
